import { h } from "preact";

export const caretNext = (
  <svg
    width="9"
    height="13"
    viewBox="0 0 9 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.10737 2.01102C2.60171 3.96516 4.32595 5.4595 6.50999 6.60899C5.93524 6.26414 1.79707 10.7472 1.33727 11.3219C0.647576 12.0116 1.68212 12.9312 2.37182 12.3565C4.09606 10.6322 6.50999 8.90798 7.88938 6.95384C8.34918 6.37909 7.65948 5.80435 7.19969 5.4595C5.3605 4.19505 3.75121 3.16051 2.37182 1.32132C1.79707 0.516677 0.532628 1.20637 1.10737 2.01102Z"
      fill="currentColor"
    />
  </svg>
);

export const caretPrevious = (
  <svg
    width="9"
    height="13"
    viewBox="0 0 9 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.89458 2.01102C6.40024 3.96516 4.676 5.4595 2.49196 6.60899C3.06671 6.26414 7.20488 10.7472 7.66468 11.3219C8.35438 12.0116 7.31983 12.9312 6.63014 12.3565C4.9059 10.6322 2.49196 8.90798 1.11257 6.95384C0.652774 6.37909 1.34247 5.80435 1.80227 5.4595C3.64146 4.19505 5.25075 3.16051 6.63014 1.32132C7.20488 0.516677 8.46933 1.20637 7.89458 2.01102Z"
      fill="currentColor"
    />
  </svg>
);

export const plusDrawn = (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.80339 0.373274C5.9055 2.4067 5.91685 4.43445 5.76961 6.46581C5.69793 7.45209 5.50609 8.41801 5.38799 9.3981C5.34751 9.7346 5.41584 10.8942 5.29981 11.1172C5.53549 11.1479 5.77116 11.1788 6.00684 11.2095C5.99885 11.1732 5.99085 11.1365 5.98286 11.1002C5.87637 10.6128 5.13066 10.8196 5.23689 11.306C5.24463 11.3423 5.25288 11.3787 5.26087 11.415C5.33127 11.7376 5.81603 11.799 5.96765 11.5073C6.11591 11.2222 6.05893 10.8261 6.06073 10.5162C6.06718 9.48861 6.34282 8.48221 6.44777 7.46395C6.69092 5.1028 6.6953 2.74191 6.57669 0.373016C6.55194 -0.123092 5.77838 -0.12567 5.80339 0.373274Z"
      fill="currentColor"
    />
    <path
      d="M0.36899 6.04597C2.29231 6.27237 4.22001 6.30099 6.15442 6.29557C8.05789 6.29042 10.0872 6.56065 11.9723 6.36829C12.4636 6.31826 12.4685 5.54419 11.9723 5.59473C10.2396 5.77162 8.38691 5.5117 6.63738 5.51995C4.54207 5.52975 2.45269 5.51763 0.36899 5.27242C-0.125829 5.21414 -0.120156 5.98847 0.36899 6.04597Z"
      fill="currentColor"
    />
  </svg>
);
